import {NavigationPages} from "@/frontendClasses/NavigationPages";
import type {PageData} from "@/frontendClasses/PageData";

/**
 * Jeśli są ustawione przekierowania na jakichś stronach, to zwraca je, inaczej zwraca podaną w parametrze stronę
 * @param navigationPage
 */
export function getNavigationPageRedirection(navigationPage:NavigationPages, navigationData?: PageData): {
    navigationPage: NavigationPages;
    navigationData: PageData | undefined
} {
    let pageName =  NavigationPages[navigationPage] as keyof typeof NavigationPages;

    if(self['nfHotelPageRedirections']){
        const redirection = self['nfHotelPageRedirections'][pageName] ;
        if(redirection !== undefined){
            for(let pageId in NavigationPages){
                if(NavigationPages[pageId] === redirection) {
                    return {navigationPage: <unknown>pageId as NavigationPages, navigationData};
                }
            }
            throw Error('Próbowano przekierować ze strony '+pageName+' na nieznaną stronę: ' + redirection +',  sprawdź swój obiekt nfHotelPageRedirections');
        }
    }
    return {navigationPage, navigationData};

}